import {ResourceType} from "@/model/ThingModel";
import _ from 'lodash'

const commonRules = {
    name: [
        {required: true, message: '请输入功能名称', trigger: ['blur']},
    ],
    identifier: [
        {required: true, message: '请输入标识符', trigger: ['blur']},
    ],
}

const commonFunRules = _.merge({}, commonRules, {
    funId: [
        {required: true, message: '请输入功能ID', trigger: ['blur']},
    ],
})

const propRules = _.merge({}, commonRules, {})

const eventRules = _.merge({}, commonFunRules, {})

const serviceRules = _.merge({}, commonFunRules, {})

export function funRules(resourceType: ResourceType) {
    switch (resourceType) {
        case ResourceType.PROPERTY:
            return propRules
        case ResourceType.EVENT:
            return eventRules
        case ResourceType.SERVICE:
            return serviceRules
    }
}